import { Link } from "react-router-dom";
import { courierAdvantages } from "@/mocks/courier";

export default function CourierSection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="relative order-2 lg:order-1">
            <div className="h-[280px] w-full overflow-hidden rounded-lg md:h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=smiling%20delivery%20courier%20handing%20a%20warm%20insulated%20food%20bag%20to%20a%20customer%20at%20a%20doorstep%2C%20bright%20warm%20daylight%2C%20orange%20and%20amber%20tones%2C%20friendly%20editorial%20photography%2C%20cinematic%20and%20clean%2C%20high%20detail&width=1000&height=800&seq=home-courier-section&orientation=landscape"
                alt="美味的快递同城配送服务"
                title="美味的快递 - 同城急送服务"
                className="h-full w-full object-top"
              />
            </div>
            <div className="absolute -bottom-5 left-5 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-5 py-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-timer-flash-line text-2xl" />
              </span>
              <span>
                <span className="block font-heading text-lg font-extrabold text-foreground-950">30 分钟</span>
                <span className="block text-xs text-foreground-500">同城平均送达</span>
              </span>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-bold text-accent-700">
              <i className="ri-e-bike-2-line" />
              快递服务
            </span>
            <h2 className="mt-4 font-heading text-2xl font-extrabold text-foreground-950 md:text-4xl">
              不只是送餐，更是可靠的同城快递
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              自建配送网络覆盖全城 120+ 片区，生鲜、药品、文件都能寄。寄件下单、实时追踪、保价理赔，一站搞定。
            </p>

            <ul className="mt-7 flex flex-col gap-4">
              {courierAdvantages.map((a) => (
                <li key={a.title} className="flex gap-3.5">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-50 text-accent-600">
                    <i className={`${a.icon} text-xl`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-sm font-bold text-foreground-950">{a.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-500">{a.desc}</p>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/courier-send"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3.5 text-sm font-bold text-background-50 transition hover:bg-accent-600"
              >
                <i className="ri-send-plane-fill" />
                立即寄件
              </Link>
              <Link
                to="/courier-track"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-bold text-foreground-800 transition hover:border-accent-300 hover:bg-accent-50"
              >
                <i className="ri-search-eye-line" />
                查询快递
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}